import commonFn from '@/commons/commonFunction.js';
import {showConfirm, showConfirmValidate, showError} from '@/commons/globalMessage';
// store
import {useGlobalSocketStore} from '@/stores/globalSocketStore';
// enum
import WebSocketEvent from '@/commons/wildcards/constants/WebSocketEvent';
import popupUtil from '@/commons/popupUtil';
import FormState from '@/commons/wildcards/constants/FormState';
import i18nEtreasuryProcess from '@/i18ns/vi/etreasury/i18nEtreasuryProcess';
import DvcUserApi from '@/apis/dvc/dvcUserApi';
import fileApi from '@/apis/fl/fileApi.js';

export const useDvcCommon = () => {
  const globalStore = useGlobalSocketStore();

  /**
   * Kiểm tra phiên đăng nhập DVC còn không
   * nhhoang1 26.09.2023
   */
  const isDvcAuth = () => {
    const tokenExpire = commonFn.getLocalStorage('DvcTokenExpire');

    if (tokenExpire) {
      var expire = new Date(tokenExpire);
      if (expire && expire > new Date()) {
        return true;
      }
    }

    return false;
  };

  /**
   * Xóa thông tin local storage khi logout
   * nhhoang1 27.09.2023
   * @modified nvthinh 15.11.2023: Xóa dvc context khi logout
   * @modified nvthinh 28.11.2023: Clear interval khi logout
   */
  const logout = () => {
    commonFn.removeLocalStorage('DvcToken');
    commonFn.removeLocalStorage('DvcTokenExpire');
    commonFn.removeLocalStorage('DvcUser');
    commonFn.removeLocalStorage('DvcRole');
    commonFn.removeLocalStorage('DvcApprovers');

    globalStore.clearIntervalByKey(WebSocketEvent.GetDocumentStatusDvc);
  };

  /**
   * @description Xử lý sau khi sinh hạch toán thành công từ dvc
   * Các chứng từ áp dụng hiện tại: Rút tiền kho bạc, Chuyển khoản kho bạc, CKKB vào TKTG, Nộp tiền kho bạc, Chi tiền gửi, Phiếu kết chuyển
   * @author nvthinh 15.2.2024
   */
  const afterGenerateAccountingSuccess = () => {
    // Thực hiện callback đối với luồng sinh hạch toán từ dvc
    if (window?.isFromDVCFile) {
      if (
        window.callBackFuncs?.afterSuccessfulPayment &&
        typeof window.callBackFuncs?.afterSuccessfulPayment == 'function'
      ) {
        window.callBackFuncs.afterSuccessfulPayment();
      }

      // Loại bỏ các biến global sau khi sử dụng xong
      delete window.isFromDVCFile;
      delete window.callBackFuncs;
    }
  };

  /**
   * show form hồ sơ từ màn hình danh sách chứng từ
   * nhhoang1 27.11.2023
   * @modified nvthinh 31.07.2024: truyền thêm tham số param phục vụ custom thêm formParam
   */
  const showDvcFileDetailFromVoucher = (formName, dvcFileId, dvcFileCode, param = {}) => {
    if (!dvcFileId || !formName || !dvcFileCode) return;

    // Check xem hồ sơ của mã QHNS có khác với mã QHNS đang đăng nhập ?
    if (checkBudgetCodeOther(formName, dvcFileId, dvcFileCode)) {
      return;
    }

    showFormDvcFile(formName, dvcFileId, param);
  };

  /**
   * show form chi tiết hồ sơ
   * @param {*} dvcFileId
   * nhhoang1 26.02.2024
   * @modified nvthinh 31.07.2024: truyền thêm tham số param phục vụ custom thêm formParam
   */
  const showFormDvcFile = (formName, dvcFileId, param = {}) => {
    const callBackFn = param.callBackFn ?? {};

    popupUtil.show(formName, {
      id: dvcFileId,
      mode: FormState.View,
      ...param,
      options: {
        callBackRefresh: function () {},
        submit: function (saveResult, saveParam) {},
        ...callBackFn,
      },
    });
  };

  /**
   * Check xem hồ sơ của mã QHNS có khác với mã QHNS đang đăng nhập ?
   * @param {*} dvcFileCode
   * nhhoang1 26.02.2024
   */
  const checkBudgetCodeOther = (formName, dvcFileId, dvcFileCode) => {
    let lstFileCodeSplit = dvcFileCode.split('_'),
      isOther = false,
      dvcUser = JSON.parse(commonFn.getLocalStorage('DvcUser'), '{}');

      if (!dvcUser) {
      let title = 'Kết nối KBĐT',
        message = `Tài khoản kho bạc điện tử của bạn đang ngắt kết nối. Vui lòng kết nối lại  để xem hồ sơ <b>${commonFn.processXssValue(
          dvcFileCode,
        )}</b>.`;

      showConfirmValidate(message, title, {Yes: 'Kết nối', No: 'Hủy'}, 480).then(async answer => {
        if (answer) {
          location.href = window._etreasury.etreasuryUrl;
        }
      });

      return true;
    }

    if (!lstFileCodeSplit || lstFileCodeSplit.length != 3 || !dvcUser || !dvcUser.budget_code) {
      isOther = true;
    }

    // Check xem hồ sơ của mã QHNS có khác với mã QHNS đang đăng nhập
    if (!isOther && lstFileCodeSplit[1] == dvcUser.budget_code) {
      isOther = false;
    } else {
      isOther = true;
    }

    // cảnh báo nếu mã QHNS khác nhau
    if (isOther) {
      let title = 'Không thể xem',
        message = `Bạn đang đăng nhập Kho bạc điện tử theo mã QHNS <b>${commonFn.processXssValue(
          dvcUser.budget_code,
        )}</b>. Bạn có muốn đăng nhập đúng mã QHNS để xem hồ sơ?`;

      showConfirm(message, title, 430).then(async answer => {
        if (answer) {
          commonFn.mask();

          let payload = {
            BudgetCode: lstFileCodeSplit[1] || '',
            ComputerName: navigator.userAgent,
          };

          // logout đơn vị cũ trước khi chuyển đơn vị mới
          let dvcToken = commonFn.getLocalStorage('DvcToken');
          await DvcUserApi.logout(dvcToken);
          logout();

          // call api
          await DvcUserApi.transfer(payload)
            .then(result => {
              if (result && result.LoginStatus == 1 && result.User && result.Token) {
                // Lưu thông tin DVC vào localStorage
                commonFn.setLocalStorage('DvcToken', result.Token);
                commonFn.setLocalStorage('DvcTokenExpire', new Date().addSeconds(result.TokenTimeout));
                commonFn.setLocalStorage('DvcUser', JSON.stringify(result.User));
                commonFn.setLocalStorage('DvcRole', result.User?.user_type);
                commonFn.setLocalStorage('DvcApprovers', JSON.stringify(result.Approvers));

                const intervalId = globalStore.mapTimeInterval[WebSocketEvent.GetDocumentStatusDvc];

                if (!intervalId) {
                  globalStore.triggerEventDVC();
                }

                showFormDvcFile(formName, dvcFileId);
              } else {
                let message = i18nEtreasuryProcess.Message.ErrorLogin.format('style="color: #0078d7;"');

                showError(message, i18nEtreasuryProcess.Message.ConnectFail, 500);
              }
            })
            .finally(() => {
              commonFn.unmask();
            });
        }
      });
    }

    return isOther;
  };

  /**
   * download file đăng ký kbnn
   * nhhoang1 26.02.2024
   */
  const downloadFile = async budgetCode => {
    var fileName = await DvcUserApi.getDownloadLink();

    if (!fileName) {
      return;
    }

    var downloadFileName = proxy.$t('i18nEtreasuryProcess.FileName');

    // Gen link download
    let downloadLink = fileApi.getDownloadLink(proxy.$ms.constant.StorageFileType.Temp, fileName, downloadFileName);

    // Download link
    commonFn.downloadLink(downloadLink);
  };

  /**
   * Hiện thị pop-up chuyển đổi đơn vị giao dịch với KBNN PBI-71595
   * nhhoang1 23.02.2024
   */
  const showPopupDvcTransferUnit = (fnCallbackSuccess, fnCallbackFail) => {
    popupUtil.show('DvcTransferUnit', {
      options: {
        fnCallbackSuccess,
        fnCallbackFail,
      },
    });
  };

  return {
    isDvcAuth,
    logout,
    showPopupDvcTransferUnit,
    afterGenerateAccountingSuccess,
    showDvcFileDetailFromVoucher,
    downloadFile,
  };
};
